import { Event } from "@iloq/shared";
import { queryOptions } from "@tanstack/react-query";
import type { AxiosInstance } from "axios";

const GET_PARTNER_EVENTS_QUERY_KEY = "getPartnerEvents";

export function getEventsQueryOptions({
  axiosInstance,
  countryCode,
  languageCode,
  enabled = !!countryCode && !!languageCode,
}: {
  axiosInstance: AxiosInstance;
  countryCode: string;
  languageCode: string;
  enabled?: boolean;
}) {
  return queryOptions({
    queryKey: [GET_PARTNER_EVENTS_QUERY_KEY, countryCode, languageCode],
    staleTime: 1000 * 60 * 60 * 1, // Hourly cache
    queryFn: async (): Promise<Event[]> => {
      const response = await axiosInstance.get<Event[]>(
        "/api/v2/events/event",
        {
          params: {
            countryCode,
            languageCode,
          },
        },
      );
      return response.data;
    },
    enabled,
  });
}
